module.exports = __webpack_public_path__ + "static/img/F2_new.a748ba7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/F2_new.png
// module id = VrVf
// module chunks = 1